import { render, staticRenderFns } from "./ResponsibilityForm.vue?vue&type=template&id=3cee1d2e&"
import script from "./ResponsibilityForm.vue?vue&type=script&lang=js&"
export * from "./ResponsibilityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports